import React, { useState } from "react";
import { Formik } from "formik";
import {
    withStyles,
    Button,
    Typography,
    CircularProgress,
    Tooltip,
    IconButton,
    DialogTitle,
    Dialog,
    Grid,
} from "@material-ui/core";
import { CloudDownload } from "@material-ui/icons";
import * as Yup from "yup";
import { DropzoneArea } from 'material-ui-dropzone';
import config from "../../../config/config";
import { externalDownload } from "../../sc-utilities/download.utils";
import { snackActions } from "../../sc-utilities/SnackBar";
import { capitalize } from "../../sc-utilities";
import ExportForm from '../../sc-components/ExportForm/ExportForm';

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        width: "100%"
    }
});

let initialValues = [
    'Excel',
    'JSON',
    'CSV',
    'XML',
    'Download',
    "Email",
    "includePDFReports",
    "includeDiagnoseReports",
    "includeVerificationReports",
    "includeAggregatedPDFErasureReports",
    "includeAggregatedPDFVerificationReports",
    "includeSummaryPDFErasureReports",
    "includeSummaryPDFVerificationReports",
];

const ReportFinderForm = props => {
    const { classes, formSettings, loading, handleSubmit, translations, handleUpload, groups } = props;
    const [isOpen, setIsOpen] = useState(false);

    const handleDownload = async () => {
        const objectURL = `${config.web}/assets/example-report-finder.xlsx`;
        let exportDataSuccessful = await externalDownload(objectURL);
        if (!exportDataSuccessful) {
            return snackActions.snackBarComponent(translations['download_error_msg'] || `Could not download file `, 'error');
        }
    };
    return (
        <div className={classes.root}>
            <Typography>
                {translations['supported_formats'] || 'Supported formats'}: .csv, .xls, .xlsx.<br />
            </Typography>
            <Tooltip title={translations['download_example_report_finder'] || 'Download example report finder file'}>
                <IconButton component='div' aria-label={translations['download_example_report_finder'] || 'Download example report finder file'}
                    onClick={() => handleDownload()}>
                    {<CloudDownload />}
                </IconButton>
            </Tooltip>
            <Formik
                initialValues={formSettings.InitialValues}
                onSubmit={async (values, { setSubmitting }) => {
                    setSubmitting(true);
                    await handleSubmit(values);
                    setSubmitting(false);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { isValid, dirty, isSubmitting, } = formikProps;
                    return (
                        <form>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <div>
                                <DropzoneArea
                                    filesLimit={1}
                                    maxFileSize={5368709120}
                                    getFileRemovedMessage={(fileName) => {
                                        const text = translations ? (
                                            capitalize(`${translations['file'] || 'File'} ${fileName} ${translations['removed'] || 'removed'}.`)
                                        ) : `File ${fileName} removed.`
                
                                        return text;
                                    }}
                                    getFileAddedMessage={(fileName) => {
                                        const text = translations ? (
                                            capitalize(`${translations['file'] || 'File'} ${fileName} ${translations['successfully_added'] || 'successfully added'}.`)
                                        ) : `File ${fileName} successfully added.`
                
                                        return text;
                                    }}
                                    getFileLimitExceedMessage={(filesLimit) => {
                                        const text = translations ? (
                                            capitalize(`${translations['maximum_allowed_number'] || 'Maximum allowed number of files exceeded. Only'} ${filesLimit} ${translations['allowed'] || 'allowed'}.`)
                                        ) : `Maximum allowed number of files exceeded. Only ${filesLimit} allowed`
                
                                        return text;
                                    }}
                                    getDropRejectMessage={(rejectedFile) => {
                                        const text = translations ? (
                                            capitalize(`${translations['File'] || 'File'} ${translations['was_rejected'] || 'was rejected'}.`)
                                        ) : `File was rejected.`
                
                                        return text;
                                    }}
                                    dropzoneText={translations['drag_and_drop_file_or_click'] || 'Drag and drop a file or click here'}
                                    onChange={handleUpload}
                                    acceptedFiles={['.csv', '.xls', '.xlsx']}
                                />
                            </div>
                            <div>
                                {
                                    formSettings.ButtonSubmit ? (
                                        <Button
                                            className={classes.submit}
                                            variant="contained"                                         
                                            onClick={() => setIsOpen(true)}
                                            disabled={!(isValid && dirty) || isSubmitting ? loading : false}
                                        >
                                            {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                        </Button>
                                    ) : null
                                }
                                {                            
                                       <Dialog classes={{ paper: classes.dialogPaper }} onClose={() => setIsOpen(false)} aria-labelledby="customized-dialog-title" open={isOpen} fullWidth={true}
                                       maxWidth={'md'} >
                                       <DialogTitle className={classes.title}>{`${translations['create_report_finder']}`} </DialogTitle>
                                       <Grid container >
                                           <Grid item xs={12}>
                                               <ExportForm
                                                   setIsOpen={setIsOpen}
                                                   initialValues={initialValues}
                                                   formSettings={formSettings}
                                                   translations={translations}
                                                   handleDownload={handleSubmit}
                                                   groups={groups}
                                                   showProductOverviewExportTypes={true} 
                                                   showProductOverviewOutputMode={true}
                                               />
                                           </Grid>
                                       </Grid>
                                   </Dialog>
                                }
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(ReportFinderForm);